export default {
  LOGGER_NAMESPACE: 'corvus',
  COMPONENT_SERVERLESS_CORE: 'serverless-core',
  COMPONENT_EVENT_BUS_CLIENT: 'event-bus-client',
  CONNECTION_SIGNAL_STATUS_RED: 'RED',
  CONNECTION_SIGNAL_STATUS_YELLOW: 'YELLOW',
  CONNECTION_SIGNAL_STATUS_GREEN: 'GREEN',
  CONNECTION_SIGNAL_STATUS_CLOSED: 'CLOSED',
  CONNECTION_SIGNAL_STATUS_RELOADING: 'RELOADING',
  CONNECTION_SIGNAL_STATUS_MANUALLY_DISCONNECTED: 'MANUALLY_DISCONNECTED',
  MESSAGE_TYPE_RESPONSE: 'RESPONSE',
  MESSAGE_TYPE_ACK: 'ACK',
  MESSAGE_TYPE_CONNECTION_SIGNAL: 'CONNECTION_SIGNAL',
  MESSAGE_TYPE_INITIALISER: 'INITIALISER',
  MESSAGE_TYPE_INTERNAL: 'INTERNAL',
  MESSAGE_TYPE_ERROR: 'ERROR',
  SUBSCRIBE_EVENT: 'subscribe',
  UNSUBSCRIBE_EVENT: 'unsubscribe',
  CONNECTION_EVENT: 'connection',
  DISCONNECTION_EVENT: 'disconnection',
  PING_EVENT: 'ping',
  GREEN_SIGNAL_EVENT: 'greenSignal',
  GET_CONTEXT_USER_PROFILE_EVENT: 'getUserProfile',
  POST_DEPLOY_BACKEND_EVENT: 'post-deploy:backend',
  POST_DEPLOY_FRONTEND_EVENT: 'post-deploy:frontend',
  PRE_UNDEPLOY_BACKEND_EVENT: 'pre-undeploy:backend',
  // AWS Closes connection after 10 minutes idle
  // define a lower time (ms) to prevent APIGATEWAY Idle Timeout
  PING_REQUEST_IDLE_TIME_MS: 9 * 60 * 1000,
  // Role credentials safety tolerance (ms)
  AWS_SAFETY_RENEW_ROLE_CREDENTIALS: 15 * 60 * 1000,
  /// Core Events ///
  CORE_MOCK_COGNITO_ATTRIBUTES: 'coreMockCognitoAttributes',
  CORE_BUILD_SECURE_CONNECTION_PARAMS: 'coreBuildSecureConnectionParams',
  CORE_GET_APPLICATION_USER_PROFILE: 'coreGetApplicationUserProfile',
  CORE_ALLOW_CONNECTION: 'coreAllowConnection',
  CORE_POST_DEPLOY_BACKEND: 'corePostDeployBackend',
  CORE_POST_DEPLOY_FRONTEND: 'corePostDeployFrontend',
  CORE_PRE_UNDEPLOY_BACKEND: 'corePreUndeployBackend',
  DEFAULT_USER_EMAIL: 'corvus@corvus.com',
  DEFAULT_USER_PASSWORD: 'Corvus@123',
  WEBSOCKET_PAYLOAD_SIZE: 100000,
  CORVUS_PRE_UNDEPLOY_QUEUE: 'corvus-pre-undeploy-finished'
}
